<!-- Header -->
<form [formGroup]="layoutLineForm">
  <!-- Header -->
  <div class="row mb-3">
    <div class="col-md-4">
      <label>Layout Short Code</label>
      <input class="form-control" formControlName="LayoutShortCode" />
    </div>
    <div class="col-md-4">
      <label>Description</label>
      <input class="form-control" formControlName="LayoutDescription" />
    </div>
    <div class="col-md-4">
      <label>Remarks</label>
      <input class="form-control" formControlName="LayoutRemarks" />
    </div>
  </div>

  <!-- Group Toggles -->
  <div class="mb-2">
    <button class="btn btn-sm btn-outline-secondary me-2" type="button" (click)="toggleGroup('group2')">Source</button>
    <button class="btn btn-sm btn-outline-secondary me-2" type="button" (click)="toggleGroup('group3')">Shape</button>
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleGroup('group4')">Text</button>
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleGroup('group5')">Position</button>
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleGroup('group6')">Comment</button>
    <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleGroup('group7')">Auto</button>
  </div>

  <!-- Detail Table -->
  <div class="table-responsive">
    <table class="table table-bordered table-sm align-middle">
      <thead class="table-light">
        <tr>
          <th>Sr No</th>
          <th>Name</th>
          <th>Shape TYpe</th>
          <th *ngIf="groupVisibility.group2">Source</th>
          <th *ngIf="groupVisibility.group2">Lable</th>
          <th *ngIf="groupVisibility.group3">Shape Border</th>
          <th *ngIf="groupVisibility.group3">Shape shadow</th>
          <th *ngIf="groupVisibility.group3">Shape fill</th>
          <th *ngIf="groupVisibility.group4">Text size</th>
          <th *ngIf="groupVisibility.group4">Text Color</th>
          <th *ngIf="groupVisibility.group5">Xpos</th>
          <th *ngIf="groupVisibility.group5">Ypos</th>
          <th *ngIf="groupVisibility.group5">Width</th>
          <th *ngIf="groupVisibility.group5">Height</th>
          <th *ngIf="groupVisibility.group6">Comment</th>
          <th *ngIf="groupVisibility.group7">Auto source</th>
          <th *ngIf="groupVisibility.group7">Auto value</th>
          <th *ngIf="groupVisibility.group7">Auto condition</th>

          <th>Actions</th>
        </tr>
      </thead>
      <tbody formArrayName="details">

        <tr *ngFor="let row of detailsFormArray.controls; let i = index" [formGroupName]="i">
          <td>{{ i + 1 }}</td>
          <!---          <td><input type="text" class="form-control form-control-sm" formControlName="LayLineSrNo" /></td>
-->
          <td><input type="text" class="form-control form-control-sm" formControlName="LLName" /></td>
          <td>
            <select class="form-select form-select-sm" formControlName="LLShapeType">
              <option *ngFor="let shapetype of ShapeTypeOptions" [value]="shapetype.SLObjectType">
                {{ shapetype.SLObjectType }}
              </option>
            </select>
          </td>
          <td *ngIf="groupVisibility.group2">
            <input type="text" class="form-control form-control-sm" formControlName="LLSource" />
          </td>
          <td *ngIf="groupVisibility.group2">
            <input type="text" class="form-control form-control-sm" formControlName="LLLable" />
          </td>

          <td *ngIf="groupVisibility.group3">
            <select class="form-control" formControlName="LLShapeBorder">
              <option value="">Select border Type</option>
              <option *ngFor="let shapeBorderType of shapeBorderTypes" [value]="shapeBorderType.ValidVal">{{
                shapeBorderType.ValidVal }}</option>
            </select>
          </td>
          <td *ngIf="groupVisibility.group3">
            <select class="form-control" formControlName="LLShapeShadow">
              <option value="">Select shadow Type</option>
              <option *ngFor="let shapeShadowType of shapeShadowTypes" [value]="shapeShadowType.ValidVal">{{
                shapeShadowType.ValidVal }}</option>
            </select>
          </td>
          <td *ngIf="groupVisibility.group3">
            <input type="text" class="form-control form-control-sm" formControlName="LLShapeFill" />
          </td>

          <td *ngIf="groupVisibility.group4">
            <input type="text" class="form-control form-control-sm" formControlName="LLTextFont" />
          </td>
          <td *ngIf="groupVisibility.group4">
            <input type="text" class="form-control form-control-sm" formControlName="LLTextColor" />
          </td>
          <td *ngIf="groupVisibility.group5">
            <input type="text" class="form-control form-control-sm" formControlName="LLXpos" />
          </td>
          <td *ngIf="groupVisibility.group5">
            <input type="text" class="form-control form-control-sm" formControlName="LLYpos" />
          </td>
          <td *ngIf="groupVisibility.group5">
            <input type="text" class="form-control form-control-sm" formControlName="LLWidth" />
          </td>
          <td *ngIf="groupVisibility.group5">
            <input type="text" class="form-control form-control-sm" formControlName="LLHeaight" />
          </td>
          <td *ngIf="groupVisibility.group6">
            <input type="text" class="form-control form-control-sm" formControlName="LLComment" />
          </td>
          <td *ngIf="groupVisibility.group7">
            <select class="form-select form-select-sm" formControlName="LLAutoSource">
              <option value="">—</option>
              <option *ngFor="let s of lineAutoSources" [value]="s">{{ s }}</option>
            </select>
          </td>
          <td *ngIf="groupVisibility.group7">
            <input type="text" class="form-control form-control-sm" formControlName="LLAutoVal" maxlength="45" />
          </td>
          <td *ngIf="groupVisibility.group7">
            <select class="form-select form-select-sm" formControlName="LLAutoCondition">
              <option value="">—</option>
              <option *ngFor="let c of lineAutoConditions" [value]="c">{{ c }}</option>
            </select>
          </td>

          <td class="text-nowrap">
            <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="moveRowUp(i)">↑</button>
            <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="moveRowDown(i)">↓</button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteRow(i)">🗑️</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mb-3">
    <button type="button" class="btn btn-outline-primary" (click)="addRow()">➕ Add Row</button>
  </div>

  <div class="text-end">
    <button type="button" class="btn btn-success" (click)="save()">💾 Save</button>
  </div>
</form>